import { ExperimentProviderContext } from '@carvana/experiment';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';

export default function useSendExperimentsToDataDog() {
  const { experiments } = useContext(ExperimentProviderContext);

  useEffect(() => {
    const experimentsWithBucket = Object.entries(experiments).reduce<
      Record<string, string>
    >((acc, [key, value]) => {
      acc[key] = value.assignedBucket ?? 'unknown';

      return acc;
    }, {});

    datadogRum.addRumGlobalContext('experiments', experimentsWithBucket);
  }, [experiments]);
}
